// Utility to manage plan sidebar state persistence across pages

const STORAGE_KEY = 'plan_sidebar_open';

export const PlanSidebarState = {
  // Get the current sidebar state from localStorage
  isOpen(): boolean {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      // Default to closed if not set
      return stored === 'true';
    } catch (error) {
      return false;
    }
  },

  // Set the sidebar state in localStorage
  setOpen(isOpen: boolean): void {
    try {
      localStorage.setItem(STORAGE_KEY, String(isOpen));
      // Dispatch a custom event so other components can listen for changes
      window.dispatchEvent(new CustomEvent('plan-sidebar-state-changed', {
        detail: { isOpen }
      }));
    } catch (error) {
      console.error('Error saving sidebar state:', error);
    }
  },

  // Toggle the sidebar state
  toggle(): boolean {
    const newState = !this.isOpen();
    this.setOpen(newState);
    return newState;
  },

  // Clear the stored state (useful for logout)
  clear(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing sidebar state:', error);
    }
  }
};